/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Map } from 'immutable';
import { actionTypes as authActionTypes } from '../actions/authentication';

const initialState = new Map();

// Setting values always returned as strings, convert to appropriate type
function mapAccountSettingValue(settingType, settingValue) {
  if (settingType === 'PRICING_ENABLED') {
    return settingValue === 'true';
  }
  return settingValue;
}

// Convert list of account settings to K:V pairs
function mapAccountSettings(settingsList) {
  const settingsMap = new Map(
    settingsList.map(s => [
      s.accountSettingType,
      mapAccountSettingValue(s.accountSettingType, s.accountSettingValue),
    ])
  );

  return settingsMap;
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case authActionTypes.AUTH_LOGIN_SUCCESS:
    case authActionTypes.AUTH_REFRESH_SUCCESS:
    case authActionTypes.AUTH_CHECK_SUCCESS: {
      const settingsMap = mapAccountSettings(action.accountSettings ? action.accountSettings : []);
      return state.merge(settingsMap);
    }
    default: {
      return state;
    }
  }
}
